import { render, staticRenderFns } from "./DeptRoleTeacherSelect.vue?vue&type=template&id=5b4940a4&scoped=true"
import script from "./DeptRoleTeacherSelect.vue?vue&type=script&lang=js"
export * from "./DeptRoleTeacherSelect.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleTeacherSelect.vue?vue&type=style&index=0&id=5b4940a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4940a4",
  null
  
)

export default component.exports